import React from 'react';
import SEOHead from '../components/shared/SEOHead';
import { getPageSEO } from '../utils/seoConfig';
import LandingPageNavbar from '../components/landing-page/LandingPageNavbar';
import Heading from '../components/documentGeneratorLandingPage/Heading';
import AboutSection from '../components/documentGeneratorLandingPage/AboutSection';
import KeyFeaturesSection from '../components/documentGeneratorLandingPage/KeyFeaturesSection';
import HowWorks from '../components/documentGeneratorLandingPage/HowWorks';
import PartnersTestimonials from '../components/landing-page/PartnersTestimonials';
import Footer from '../components/landing-page/Footer';
import SelectPresentationType from '../components/presentation-type/SelectPresentationType';
import SlideCreationOptions from '../components/documentGeneratorLandingPage/SlideCreationOptions';
import FaqSection from '../components/documentGeneratorLandingPage/FaqSection';
import BuildingSection from '../components/documentGeneratorLandingPage/BuildingSection';
import {Theme} from "../lib/theme"
import DocumentInput from "../components/documentInput/documentInput"
import Navbar from '../components/shared/Navbar';

const NewPresentationLandingPage: React.FC = () => {
  const authToken = sessionStorage.getItem("authToken");
  const isLoggedIn = !!authToken;
  sessionStorage.setItem("redirectAfterAuth","/new-document")
  
  console.log('NewPresentationLandingPage rendered, isLoggedIn:', isLoggedIn);
//Create a presentation on optimal financial planning benefits be precise with the content include charts and points
  return (
    <>
      <SEOHead seo={getPageSEO("newDocument")} />
      <div className="no-scrollbar no-scrollbar::-webkit-scrollbar">
      {!isLoggedIn && (
        <>
          <LandingPageNavbar />
        </>
      )}

      {isLoggedIn &&(
          <Navbar />
            )}
      <div className={!isLoggedIn ? 'pt-20' : ''}>
        <DocumentInput />
      </div>
      {!isLoggedIn && (
        <>
          <div className="h-64 md:hidden"></div>
          <Heading />
          <AboutSection />
          <KeyFeaturesSection />
          <HowWorks />
          <SlideCreationOptions/>
          <FaqSection/>
          <BuildingSection/>
          
         
        </>
      )}
      
     
      
      
      {!isLoggedIn && (
        <>
          {/* <PartnersTestimonials />
          <Footer /> */}
        </>
      )}
    </div>
    </>
  );
};

export default NewPresentationLandingPage;